import React, { Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { connect } from 'react-redux';

import AppRoute, { GenSwitchRoute } from '../../Util/Route';
import { getConfig } from '../../Util/Config';
import { getProfile } from '../../Redux/user-profile/actions';
import Menu from '../../Components/Menu';
import Auth from '../Auth';
import Dashboard from '../Dashboard';
import Playground from '../Playground';
import Landing from '../Landing';
import MockExamOverview from '../MockExamOverview';
import MockExamDetails from '../MockExamDetails';
import MockExamLink from '../MockExamLink';
import MockExamManage from '../MockExamManage';
import LinkSchool from '../LinkSchool';
import BrowseUni from '../../Containers/BrowseUniversity';
import Register from '../Register';
import RegisterProfile from '../RegisterProfile';
import ForgotPassword from '../ForgotPassword';
import EmptyLinkSchool from '../LinkSchool/EmptyLinkSchool';
import ConfirmAdmission from '../ConfirmAdmission';
import NoMatch from '../NoMatch';

import AppNotification from './Components/AppNotification';

const { lineContactLink, enableStudentRegistration, tcasterAppLink } = getConfig();

const routes = [
  { path: '/', title: 'Landing', roles: [], hideMenu: true, route: Landing },

  {
    path: ConfirmAdmission.location,
    title: ConfirmAdmission.name,
    roles: [],
    private: true,
    hideMenu: true,
    route: ConfirmAdmission.component,
  },
  {
    path: '/login',
    title: 'Login',
    roles: [],
    hideMenu: true,
    route: Auth.component,
  },
  {
    title: 'NoMatch',
    roles: [],
    hideMenu: true,
    route: NoMatch,
  },
];

class RouteApp extends Component {
  componentDidMount() {
    this.props.getProfile();
  }
  render() {
    return (
      <Router>
        <div style={{ height: '100%' }}>
          <Menu menus={[]} showLogo menuProps={{ fixed: 'top' }} />
          <AppNotification />
          <GenSwitchRoute menus={routes} />
        </div>
      </Router>
    );
  }
}

export default connect(
  null,
  { getProfile },
)(RouteApp);
